// import React from "react";

// const Header = () => {
//     return (
//         <div className="header">
//             <h2>Header</h2>
//         </div>
//     );
// };

// export default Header;


import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance"; // ✅ correct instance
import { clearContextStorage } from "../utils/contextStorage";
import { clearStoredUserSession } from "../utils/userSession";

const BASE_URL = "https://mis.empowerplus.in";

const Header = () => {
    const token = localStorage.getItem("token");
    const { role } = useAuth();
    const navigate = useNavigate();
    const [fullName, setFullName] = useState("");
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [departments, setDepartments] = useState([]);



    const [financialYear, setFinancialYear] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedProject, setSelectedProject] = useState("");
    const [contextSaved, setContextSaved] = useState(false);

    useEffect(() => {

        const saved = localStorage.getItem("context");

        if (saved) {

            const ctx = JSON.parse(saved);

            setFinancialYear(ctx.fy || "");
            setSelectedDepartment(ctx.department || "");
            setSelectedProject(ctx.project || "");

            setContextSaved(true);

        }

    }, []);

    useEffect(() => {
        axios.get(`${BASE_URL}/api/auth/me`) // ✅ corrected path
            .then(res => {
                setFullName(res.data.fullName || "User");
            })
            .catch(err => {
                console.error("Failed to fetch user info:", err);
            });
    }, []);

    const handleConfirm = () => {

        if (!financialYear || !selectedDepartment || !selectedProject) {
            alert("Please select FY, Department and Project");
            return;
        }

        const context = {
            fy: financialYear,
            department: selectedDepartment,
            project: selectedProject
        };

        localStorage.setItem("context", JSON.stringify(context));

        setContextSaved(true);

    };

    const handleReset = () => {

        localStorage.removeItem("context");

        setFinancialYear("");
        setSelectedDepartment("");
        setSelectedProject("");

        setContextSaved(false);

        // navigate("/centermanagerdashboard");

    };




    const getInitials = (role) => {
        if (!role) return "?";
        const cleaned = role.replace("ROLE_", "").trim();
        return cleaned[0];
    };

    const fetchProjects = async (fy, dept) => {
        if (!fy || !dept) return;

        setLoading(true);

        try {
            const res = await fetch(
                `${BASE_URL}/projects/filter?fy=${fy}&department=${dept}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = await res.json();
            setProjects(Array.isArray(data) ? data : []);
        } catch {
            console.error("Failed to load projects");
            setProjects([]);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (financialYear && selectedDepartment) {
            fetchProjects(financialYear, selectedDepartment);
        }
    }, [financialYear, selectedDepartment]);


    const handleDepartmentChange = (dept) => {
        setSelectedDepartment(dept);
        setSelectedProject("");
        fetchProjects(financialYear, dept);
    };


    const roleMap = {
        ROLE_ADMIN: "Admin",
        ROLE_PM: "Project Manager",
        ROLE_PC: "Project Coordinator",
        ROLE_USER: "User",
        ROLE_CM: "Center Manager"
    };

    const formatRoleName = (role) => {
        if (!role) return "Guest";
        return roleMap[role] || role.replace("ROLE_", "").toLowerCase().replace(/_/g, " ");
    };


    const handleFyChange = (fy) => {
        setFinancialYear(fy);
        setSelectedDepartment("");
        setSelectedProject("");
    };

    const fetchDepartments = async () => {
        try {
            const res = await fetch(
                `${BASE_URL}/departments`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = await res.json();
            const list = Array.isArray(data) ? data : [];

            setDepartments(list);

            // restore department from context
            const saved = localStorage.getItem("context");
            if (saved) {
                const ctx = JSON.parse(saved);
                if (ctx.department) {
                    setSelectedDepartment(ctx.department);
                }
            }

        } catch {
            console.error("Failed to load departments");
        }
    };

    useEffect(() => {
        fetchDepartments();
    }, []);


    const handleProjectChange = (projectId) => {
        setSelectedProject(projectId);
    };


    return (
        // <div style={{ padding: "10px", background: "#eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        //     <h2>Welcome - {role ? role.replace("ROLE_", "") : "Guest"}</h2>
        //     <button onClick={() => navigate("/profile")} style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: "16px" }}>
        //         👤 Profile
        //     </button>
        // </div>
        <>
            <div class="container-fluid topbar-menu">
                <div className="d-flex align-items-center gap-2">

                    {/* LEFT SIDE – PROJECT CONTEXT */}
                    {/* <div style={styles.contextSection}>

                        <select
                            style={styles.select}
                            value={financialYear}
                            onChange={(e) => handleFyChange(e.target.value)}
                            disabled={contextSaved}
                        >
                            <option value="">Select FY</option>
                            <option value="23-24">2023-24</option>
                            <option value="24-25">2024-25</option>
                            <option value="25-26">2025-26</option>
                            <option value="26-27">2026-27</option>
                        </select>

                        <select
                            style={styles.select}
                            value={selectedDepartment}
                            onChange={(e) => handleDepartmentChange(e.target.value)}
                            disabled={contextSaved}
                        >
                            <option value="">Select Department</option>
                            {departments.map(d => (
                                <option key={d.id} value={d.departmentName}>
                                    {d.departmentName}
                                </option>
                            ))}
                        </select>

                        <select
                            style={styles.select}
                            value={selectedProject}
                            onChange={(e) => handleProjectChange(e.target.value)}
                            disabled={contextSaved}
                        >
                            <option value="">Select Project</option>
                            {projects.map(p => (
                                <option key={p.projectId} value={p.projectId}>
                                    {p.projectId} - {p.projectName}
                                </option>
                            ))}
                        </select>

                   

                        {!contextSaved && (
                            <button
                                style={{
                                    ...styles.confirmButton,
                                    opacity:
                                        financialYear && selectedDepartment && selectedProject ? 1 : 0.6
                                }}
                                onClick={handleConfirm}
                                disabled={!financialYear || !selectedDepartment || !selectedProject}
                            >
                                ✓ Confirm
                            </button>
                        )}

                        {contextSaved && (
                            <button
                                style={{ ...styles.confirmBtn, background: "#dc2626" }}
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                        )}
                    </div> */}


                </div>

                <div class="d-flex align-items-center gap-2">

                    <div class="logo-topbar">

                        <a href="#" class="logo-light">
                            <span class="logo-lg">
                                <img src="images/logo.png" alt="logo" />
                            </span>
                            <span class="logo-sm">
                                <img src="images/logo-sm.png" alt="small logo" />
                            </span>
                        </a>


                        <a href="#" class="logo-dark">
                            <span class="logo-lg">
                                <img src="images/logo-black.png" alt="dark logo" />
                            </span>
                            <span class="logo-sm">
                                <img src="images/logo-sm.png" alt="small logo" />
                            </span>
                        </a>
                    </div>


                    {/* <button onClick={() => window.layoutHelper?.toggleSidebarSize()} class="sidenav-toggle-button btn btn-primary btn-icon">
                        <i class="ti ti-menu-4 fs-22"></i>
                    </button> */}




                    <button class="topnav-toggle-button px-2" data-bs-toggle="collapse"
                        data-bs-target="#topnav-menu-content">
                        <i class="ti ti-menu-4 fs-22"></i>
                    </button>




                </div>

                <div class="d-flex align-items-center gap-2">

                    <div class="topbar-item">

                    </div>



                    <div class="topbar-item">
                        <div class="dropdown">
                            {/* <button class="topbar-link dropdown-toggle drop-arrow-none" data-bs-toggle="dropdown"
                                data-bs-offset="0,22" type="button" data-bs-auto-close="outside" aria-haspopup="false"
                                aria-expanded="false">
                                <i class="ti ti-bell fs-20" ></i>
                                <span class="badge badge-square text-bg-warning topbar-badge">5</span>
                            </button> */}

                            <div class="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
                                <div class="px-3 py-2 border-bottom">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0 fs-md fw-semibold">Notifications</h6>
                                        </div>
                                        <div class="col text-end">
                                            <a href="#!" class="badge text-bg-light badge-label py-1">5 Alerts</a>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ maxHeight: "300px" }} data-simplebar>



                                    <div class="dropdown-item notification-item py-2 text-wrap" id="notification-4">
                                        <span class="d-flex gap-2">
                                            <span class="avatar-md flex-shrink-0">
                                                <span class="avatar-title bg-primary-subtle text-primary rounded fs-22">
                                                    <i data-lucide="user-plus" class="fs-xl fill-primary"></i>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1 text-muted">
                                                <span class="fw-medium text-body">New user registration: Sarah
                                                    Miles</span>
                                                <br />
                                                <span class="fs-xs">Just now</span>
                                            </span>
                                            <button type="button" class="flex-shrink-0 text-muted btn btn-link p-0"
                                                data-dismissible="#notification-4">
                                                <i class="ti ti-xbox-x-filled fs-xxl"></i>
                                            </button>
                                        </span>
                                    </div>




                                    <div class="dropdown-item notification-item py-2 text-wrap" id="notification-6">
                                        <span class="d-flex gap-2">
                                            <span class="avatar-md flex-shrink-0">
                                                <span class="avatar-title bg-info-subtle text-info rounded fs-22">
                                                    <i data-lucide="message-circle" class="fs-xl fill-info"></i>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1 text-muted">
                                                <span class="fw-medium text-body">New comment on Task #142</span>
                                                <br />
                                                <span class="fs-xs">15 minutes ago</span>
                                            </span>
                                            <button type="button" class="flex-shrink-0 text-muted btn btn-link p-0"
                                                data-dismissible="#notification-6">
                                                <i class="ti ti-xbox-x-filled fs-xxl"></i>
                                            </button>
                                        </span>
                                    </div>





                                    <div class="dropdown-item notification-item py-2 text-wrap" id="notification-10">
                                        <span class="d-flex gap-2">
                                            <span class="avatar-md flex-shrink-0">
                                                <span
                                                    class="avatar-title bg-secondary-subtle text-secondary rounded fs-22">
                                                    <i data-lucide="download" class="fs-xl fill-secondary"></i>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1 text-muted">
                                                <span class="fw-medium text-body">Report ready for download</span>
                                                <br />
                                                <span class="fs-xs">3 hours ago</span>
                                            </span>
                                            <button type="button" class="flex-shrink-0 text-muted btn btn-link p-0"
                                                data-dismissible="#notification-10">
                                                <i class="ti ti-xbox-x-filled fs-xxl"></i>
                                            </button>
                                        </span>
                                    </div>




                                    <div class="dropdown-item notification-item py-2 text-wrap" id="notification-12">
                                        <span class="d-flex gap-2">
                                            <span class="avatar-md flex-shrink-0">
                                                <span class="avatar-title bg-info-subtle text-info rounded fs-22">
                                                    <i data-lucide="bell-ring" class="fs-xl fill-info"></i>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1 text-muted">
                                                <span class="fw-medium text-body">Reminder: Submit your timesheet</span>
                                                <br />
                                                <span class="fs-xs">Today, 9:00 AM</span>
                                            </span>
                                            <button type="button" class="flex-shrink-0 text-muted btn btn-link p-0"
                                                data-dismissible="#notification-12">
                                                <i class="ti ti-xbox-x-filled fs-xxl"></i>
                                            </button>
                                        </span>
                                    </div>


                                </div>


                                <a href="javascript:void(0);"
                                    class="dropdown-item text-center text-reset text-decoration-underline link-offset-2 fw-bold notify-item border-top border-light py-2">
                                    View All Alerts
                                </a>

                            </div>
                        </div>
                    </div>


                    <div class="topbar-item nav-user">
                        <div class="dropdown">
                            <a class="topbar-link dropdown-toggle drop-arrow-none px-2" data-bs-toggle="dropdown"
                                data-bs-offset="0,16" href="#!" aria-haspopup="false" aria-expanded="false">
                                {/* <img src="/images/users/user-9.jpg" width="32"
                                    class="rounded-circle me-lg-2 d-flex" alt="user-image" /> */}
                                <div
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        backgroundColor: "#1ab39478", // 🔁 Optional: Use a color based on role
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "#2f3742;",
                                        fontWeight: "bold",
                                        fontSize: "14px"
                                    }}
                                    className="me-lg-2 d-flex"
                                >
                                    {getInitials(role)}  {/* This will be "A", "P", "C", etc. */}
                                </div>
                                <div class="d-lg-flex align-items-center gap-1 d-none">
                                    {/* <h5 class="my-0">{role ? role.replace("ROLE_", "") : "Guest"}</h5> */}
                                    <h5 className="my-0">{formatRoleName(role)}</h5>
                                    <i class="ti ti-chevron-down align-middle"></i>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end">

                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">Welcome back!</h6>
                                </div>


                                {/* <a href="index.html" class="dropdown-item">
                                    <i class="ti ti-user-circle me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Admin</span>
                                </a>
                                <a href="project_manager.html" class="dropdown-item">
                                    <i class="ti ti-user-circle me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Project Manager</span>
                                </a>
                                <a href="project_coordinator.html" class="dropdown-item">
                                    <i class="ti ti-user-circle me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Project Coordinator</span>
                                </a>
                                <a href="center_manager.html" class="dropdown-item">
                                    <i class="ti ti-user-circle me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Center Manager</span>
                                </a>
                                <a href="funder.html" class="dropdown-item">
                                    <i class="ti ti-user-circle me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Funder</span>
                                </a> */}







                                <div class="dropdown-divider"></div>




                                <a onClick={() => {
                                    localStorage.removeItem("token");
                                    clearStoredUserSession();
                                    clearContextStorage();

                                    navigate("/login");
                                }}
                                    style={{ cursor: "pointer" }}
                                    class="dropdown-item text-danger fw-semibold">
                                    <i class="ti ti-logout-2 me-2 fs-17 align-middle"></i>
                                    <span class="align-middle">Log Out</span>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};




const styles = {

    confirmButton: {
        padding: "6px 10px",
        borderRadius: "6px",
        border: "none",
        background: "linear-gradient(135deg, #1c84c6, #0acf97)",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "12px",
        transition: "0.3s",
        boxShadow: "0 3px 8px rgba(37, 99, 235, 0.3)"
    },

    headerWrapper: {
        height: "60px",
        background: "#ffffff",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px"
    },

    contextSection: {
        display: "flex",
        alignItems: "center",
        gap: "10px"
    },

    select: {
        height: "32px",
        fontSize: "12px",
        padding: "4px 8px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
        background: "#fff",
        minWidth: "100px"
    },

    confirmBtn: {
        height: "32px",
        padding: "0 14px",
        fontSize: "12px",
        fontWeight: "600",
        borderRadius: "6px",
        border: "none",
        background: "linear-gradient(135deg, #2563eb, #1e40af)",
        color: "#fff",
        cursor: "pointer"
    },

    userSection: {
        display: "flex",
        alignItems: "center",
        gap: "10px"
    },

    avatar: {
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        background: "#1ab39478",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: "14px"
    },

    roleText: {
        fontSize: "14px",
        fontWeight: "500"
    },

    logoutBtn: {
        background: "transparent",
        border: "none",
        color: "#dc2626",
        cursor: "pointer",
        fontWeight: "600"
    }

};



export default Header;
